<div class="info-container" *ngIf="securityDepositInfo && securityDepositInfo.id">
    <div class="label header">{{'bikeshop.rentals.booking.security_deposit_info' | translate}}</div>

    <div class="security-deposit-container">
        <div class="header">
            <div>{{ 'bikeshop.rentals.booking.status' | translate }}</div>
            <div>{{ 'bikeshop.rentals.booking.schedule_date' | translate }}</div>
            <div *ngIf="securityDepositInfo.statusID > 0">{{ 'bikeshop.rentals.booking.date_authorized' | translate }}</div>
            <div>{{ 'bikeshop.rentals.booking.authorization_amount' | translate }}</div>
            <div *ngIf="securityDepositInfo.statusID === 2">{{ 'bikeshop.rentals.booking.captured_amount' | translate }}</div>
        </div>

        <div>
            <div>
                <div class="payment-status-label" [ngClass]="{
          'scheduled': securityDepositInfo.statusID === 0,
          'authorized': securityDepositInfo.statusID === 1,
          'captured': securityDepositInfo.statusID === 2,
          'expired': securityDepositInfo.statusID === 10,
          'authorization-failed': securityDepositInfo.statusID === 11,
          'capture-failed': securityDepositInfo.statusID === 12,
          'cancelled': securityDepositInfo.statusID === 100
        }">{{getStatus(securityDepositInfo.statusID) | translate}}</div>
            </div>
            <div>{{(securityDepositInfo.scheduleDate + 'Z') | date : countryData.AngularDateFormat + " h:mm a"}}</div>
            <div *ngIf="securityDepositInfo.statusID > 0">
                <div *ngIf="securityDepositInfo.dateAuthorized">{{(securityDepositInfo.dateAuthorized + 'Z') | date :
                countryData.AngularDateFormat + " h:mm a"}}</div>
            </div>
            <div>{{partner.CurrencySymbol}}{{securityDepositInfo.authorizationAmount.toFixed(2)}}</div>
            <div *ngIf="securityDepositInfo.statusID === 2">
                {{partner.CurrencySymbol}}{{securityDepositInfo.capturedAmount.toFixed(2)}}</div>
        </div>
    </div>

    <div *ngIf="securityDepositInfo.error" class="margin-top-16 red">
        {{securityDepositInfo.error}}
    </div>

    <div class="captured-message" *ngIf="securityDepositInfo.capturedAmount > 0 && securityDepositInfo.statusID === 2">
        {{ 'bikeshop.rentals.booking.captured_message' | translate : {
        capturedAmount: partner.CurrencySymbol +
            securityDepositInfo.capturedAmount.toFixed(2), stripePaymentIntent: securityDepositInfo.stripePaymentIntentId
    } }}
    </div>

    <div *ngIf="busy" class="margin-top-16" style="display: flex;justify-content: center;">
        <p-progressSpinner [style]="{ width: '40px', height: '40px' }" animationDuration=".5s">
        </p-progressSpinner>
    </div>

    <div class="row margin-top-16" *ngIf="!busy && securityDepositInfo && securityDepositInfo.statusID === 0">
        <div class="col-md-2"></div>
        <div class="col-md-4">
            <button pButton type="button" class="p-button-raised full-width alternate"
                    (click)="cancelAuthorization()"
                    label="{{'bikeshop.rentals.security_deposit_buttons.cancel'| translate}}"></button>
        </div>
        <div class="col-md-4">
            <button pButton type="button" class="p-button-raised full-width" (click)="authorizePayment()"
                    label="{{'bikeshop.rentals.security_deposit_buttons.authorize'| translate}}"></button>
        </div>
    </div>
    <div class="row margin-top-16" *ngIf="!busy && securityDepositInfo && securityDepositInfo.statusID === 1">
        <div class="col-md-2"></div>
        <div class="col-md-4">
            <button pButton type="button" class="p-button-raised full-width alternate"
                    (click)="releaseAuthorization()"
                    label="{{'bikeshop.rentals.security_deposit_buttons.release'| translate}}"></button>
        </div>
        <div class="col-md-4">
            <button pButton type="button" class="p-button-raised full-width"
                    (click)="captureAuthorization()"
                    label="{{'bikeshop.rentals.security_deposit_buttons.capture'| translate}}"></button>
        </div>
    </div>

</div>
